interface Props {
  disclaimer?: string;
  privacyPolicyUrl?: string;
  accentColor?: string;
}

export function FormDisclaimer({
  disclaimer,
  privacyPolicyUrl,
  accentColor,
}: Props) {
  if (!disclaimer && !privacyPolicyUrl) {
    return null;
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs leading-5 text-slate-600">
      {disclaimer && (
        <>
          <p className="mb-2 font-semibold text-slate-700">
            Submission Disclaimer
          </p>

          <p className="whitespace-pre-wrap">
            {disclaimer}
          </p>
        </>
      )}

      {privacyPolicyUrl && (
        <p className={disclaimer ? 'mt-3' : ''}>
          For more information about how your personal information is handled,
          please review the{' '}
          <a
            href={privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-strivre-burgundy underline"
          >
            Privacy Policy
          </a>
          .
        </p>
      )}
    </div>
  );
}